/**
 * Metatags for angular-ui-router
 */
var uiroutermetatags;
(function (uiroutermetatags) {
    runBlockTransitions.$inject = ["$log", "MetaTags", "$transitions"];
    var appModule = angular.module('ui.router.metatags', ['ui.router']);
    var UIRouterMetatags = /** @class */ (function () {
        /* @ngInject */
        function UIRouterMetatags() {
            this.prefix = '';
            this.suffix = '';
            this.defaultTitle = '';
            this.defaultDescription = '';
            this.defaultKeywords = '';
            this.defaultRobots = '';
            this.staticProperties = {};
            this.enableOGURL = false;
        }
        UIRouterMetatags.prototype.setTitlePrefix = function (prefix) {
            this.prefix = prefix;
            return this;
        };
        UIRouterMetatags.prototype.setTitleSuffix = function (suffix) {
            this.suffix = suffix;
            return this;
        };
        UIRouterMetatags.prototype.setDefaultTitle = function (title) {
            this.defaultTitle = title;
            return this;
        };
        UIRouterMetatags.prototype.setDefaultDescription = function (description) {
            this.defaultDescription = description;
            return this;
        };
        UIRouterMetatags.prototype.setDefaultKeywords = function (keywords) {
            this.defaultKeywords = keywords;
            return this;
        };
        UIRouterMetatags.prototype.setDefaultRobots = function (robots) {
            this.defaultRobots = robots;
            return this;
        };
        UIRouterMetatags.prototype.setStaticProperties = function (properties) {
            this.staticProperties = properties;
            return this;
        };
        UIRouterMetatags.prototype.setOGURL = function (enabled) {
            this.enableOGURL = enabled;
            return this;
        };
        UIRouterMetatags.prototype.$get = function () {
            return {
                prefix: this.prefix,
                suffix: this.suffix,
                defaultTitle: this.defaultTitle,
                defaultDescription: this.defaultDescription,
                defaultKeywords: this.defaultKeywords,
                defaultRobots: this.defaultRobots,
                staticProperties: this.staticProperties,
                enableOGURL: this.enableOGURL
            };
        };
        return UIRouterMetatags;
    }());
    appModule.provider('UIRouterMetatags', UIRouterMetatags);
    var MetaTags = /** @class */ (function () {
        /* @ngInject */
        MetaTags.$inject = ["$log", "UIRouterMetatags", "$interpolate", "$injector", "$state", "$location", "$window", "$uiRouterGlobals"];
        function MetaTags($log, UIRouterMetatags, $interpolate, $injector, $state, $location, $window, $uiRouterGlobals) {
            this.$log = $log;
            this.UIRouterMetatags = UIRouterMetatags;
            this.$interpolate = $interpolate;
            this.$injector = $injector;
            this.$state = $state;
            this.$location = $location;
            this.$window = $window;
            this.$uiRouterGlobals = $uiRouterGlobals;
            this.prerender = {};
        }

        MetaTags.prototype.update = function (tags, transition) {
            var _this = this;
            try {
                /*
                    This hack is used to resolve the lack of "this.$state.$current.locals.globals".
                    Here the resolved object is builded with all previews resolved data
                */
                var resolved = {};
                var tokens = transition.getResolveTokens();
                tokens.forEach(function (token) { return resolved[token] = transition.injector().get(token); });
                this.properties = angular.extend({}, this.UIRouterMetatags.staticProperties);

                const name = this.$state.current.name;
                var params = angular.copy(transition.params('to'));

                var keyLanguage = window.lang || window.navigator.userLanguage || window.navigator.language || 'en';

                var path = this.$location.path();
                if (path.indexOf('/en/') > -1 || path.indexOf('/tr/') > -1 || path.indexOf('/pt-PT/') > -1 || path.indexOf('/es-ES/') > -1)
                    keyLanguage = path.split('/')[1];
                else if (keyLanguage.indexOf('en-') > -1)
                    keyLanguage = 'en';
                else if (keyLanguage.indexOf('tr-') > -1)
                    keyLanguage = 'tr';


                params.langcode = keyLanguage;
                this.canonical = this.$state.href(name, params, { absolute: true });

                // Create separate param objects for each language to avoid mutation
                var paramsTr = angular.extend({}, params, { langcode: 'tr' });
                this.canonical_tr = this.$state.href(name, paramsTr, { absolute: true });

                var paramsEn = angular.extend({}, params, { langcode: 'en' });
                this.canonical_en = this.$state.href(name, paramsEn, { absolute: true });

                var paramsPt = angular.extend({}, params, { langcode: 'pt-PT' });
                this.canonical_pt = this.$state.href(name, paramsPt, { absolute: true });

                var paramsEs = angular.extend({}, params, { langcode: 'es-ES' });
                this.canonical_es = this.$state.href(name, paramsEs, { absolute: true });

                // Restore original langcode for custom canonical functions
                params.langcode = keyLanguage;


                if (this.UIRouterMetatags.enableOGURL) {
                    this.properties['og:url'] = this.$location.absUrl();
                }
                if (tags) {
                    this.title = tags.title ? this.UIRouterMetatags.prefix + (this.getValue('title', tags.title, resolved) || '') + (name.indexOf('analysis') > -1 ? '' : this.UIRouterMetatags.suffix) : this.UIRouterMetatags.defaultTitle;
                    this.description = tags.description ? this.getValue('description', tags.description, resolved) : this.UIRouterMetatags.defaultDescription;
                    this.keywords = tags.keywords ? this.getValue('keywords', tags.keywords, resolved) : this.UIRouterMetatags.defaultKeywords;
                    this.robots = tags.robots ? this.getValue('robots', tags.robots, resolved) : this.UIRouterMetatags.defaultRobots;
                    this.canonical = tags.canonical ? this.getValue('canonical', tags.canonical, resolved) : this.canonical;
                    angular.forEach(tags.properties, function (value, key) {
                        var v = _this.getValue(key, value, resolved);
                        if (v) {
                            _this.properties[key] = v;
                        }
                    });
                }
                else {
                    this.title = this.UIRouterMetatags.defaultTitle;
                    this.description = this.UIRouterMetatags.defaultDescription;
                    this.keywords = this.UIRouterMetatags.defaultKeywords;
                    this.robots = this.UIRouterMetatags.defaultRobots;
                }
                if (tags && tags.prerender) {
                    this.prerender.statusCode = tags.prerender.statusCode ? this.getValue('prerender.statusCode', tags.prerender.statusCode, resolved) : 200;
                    this.prerender.header = tags.prerender.header ? this.getValue('prerender.header', tags.prerender.header, resolved) : null;
                }
                else if (window.redirected) {
                    this.prerender.statusCode = 301;
                    this.prerender.header = window.redirected;
                    delete window.redirected;
                }
                else {
                    this.prerender.statusCode = 200;
                    this.prerender.header = null;
                }
                //this.$window.prerenderReady = true;
            }
            catch (err) {
                this.$log.error('error occured when extracting metatags:', err);
            }
        };
        MetaTags.prototype.getValue = function (tagType, tag, resolved) {
            try {
                if (!tag) {
                    return null;
                }
                else if (typeof tag === 'number') {
                    return tag;
                }
                else if (typeof tag === 'string' && tag.trim().length === 0) {
                    return null;
                }
                else if (angular.isFunction(tag) || Array.isArray(tag)) {
                    return this.$injector.invoke(tag, this, resolved);
                }
                else {
                    return this.$interpolate(tag)(resolved);
                }
            }
            catch (err) {
                this.$log.error('error occured when trying to get the value of tag:', tagType, err);
                return null;
            }
        };
        return MetaTags;
    }());
    appModule.service('MetaTags', MetaTags);
    /* @ngInject */
    function runBlockTransitions($log, MetaTags, $transitions) {
        // $transitions.onStart({}, onStart);
        $transitions.onSuccess({}, onSuccess);
        $transitions.onError({}, onError);
        // function onStart(transition) {
        //     //$window.prerenderReady = false;
        // }
        function onSuccess(transition) {
            var toState = transition.$to();
            // var fromState = transition.$from();
            if (!toState.metaTags) {
                $log.debug("MetaTags - route: \"" + toState.name + "\" does not contain any metatags");
            }
            MetaTags.update(toState.metaTags, transition);
        }
        function onError(transition) {
            if (+transition.error().type !== 5) {
                MetaTags.prerender.statusCode = 500;
                //$window.prerenderReady = true;
            }
        }
    }
    appModule.run(runBlockTransitions);
})(uiroutermetatags || (uiroutermetatags = {}));
